import { render, staticRenderFns } from "./ModalDeletePersonalizationEntry.vue?vue&type=template&id=20cf81ca&scoped=true"
import script from "./ModalDeletePersonalizationEntry.vue?vue&type=script&lang=js"
export * from "./ModalDeletePersonalizationEntry.vue?vue&type=script&lang=js"
import style0 from "./ModalDeletePersonalizationEntry.vue?vue&type=style&index=0&id=20cf81ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf81ca",
  null
  
)

export default component.exports